/* eslint-disable no-restricted-imports */
import { FC, useMemo } from 'react';
import { PostModel } from '../../../data-layer/posts/types';
import { hasAvailableProducts } from '../../../utils/hasAvailableProducts';
import { useFavoritesEnabled } from '../../../utils/useFavoritesEnabled';
import { useCardActionsFlags } from '../PostCardGrid/parts/CardActions/hooks/useCardActionsFlags';
import { PostCardStatus } from '../PostCardStatus/PostCardStatus';
import { hasPostCardStatus } from '../PostCardStatus/utils/hasPostCardStatus';
import { DEFAULT_ICON_PROPS } from './constants';
import { IconWrapper } from './styles';
import { PostCardGridIconsProps } from './typings';
import { getIconOffset } from './utils/getIconOffset';
import { getPostCardGridIcons } from './utils/getPostCardGridIcons';

export const PostCardGridIcons: FC<PostCardGridIconsProps> = ({
    post,
    withProductsPreview,
    additionalIcon,
    withStatusBadge,
    index,
}) => {
    const isFavoritesEnabled = useFavoritesEnabled();
    const { withCheckout } = useCardActionsFlags(post);

    const icons = useMemo(
        () =>
            getPostCardGridIcons(post, {
                withProductsPreview: withProductsPreview && hasAvailableProducts(post as PostModel),
                withCheckout,
            }),
        [post, withCheckout, withProductsPreview],
    );

    const showPostStatus = Boolean(withStatusBadge && hasPostCardStatus(post));

    if (!isFavoritesEnabled) {
        const getHorizontalPosition = (iconIndex: number) => ({
            right: getIconOffset(iconIndex),
        });

        return (
            <>
                {additionalIcon ? (
                    <IconWrapper key={index} {...getHorizontalPosition(0)} top={1} zIndex={1}>
                        {additionalIcon}
                    </IconWrapper>
                ) : null}
                {icons.map(({ Icon }, i) => {
                    const iconIndex = additionalIcon ? i + 1 : i;

                    return (
                        <IconWrapper
                            key={i}
                            {...getHorizontalPosition(iconIndex)}
                            top={1}
                            zIndex={1}
                        >
                            <Icon {...DEFAULT_ICON_PROPS} />
                        </IconWrapper>
                    );
                })}
            </>
        );
    }

    let slotIndex = 0;

    const getLeftPosition = () => {
        const position = { left: getIconOffset(slotIndex) };
        slotIndex += 1;

        return position;
    };

    return (
        <>
            {additionalIcon ? (
                <IconWrapper key="menu" {...getLeftPosition()} top={1} zIndex={1}>
                    {additionalIcon}
                </IconWrapper>
            ) : null}
            {showPostStatus ? (
                <IconWrapper key="status" {...getLeftPosition()} top={1} zIndex={1}>
                    <PostCardStatus post={post} position="relative" top={0} left={0} />
                </IconWrapper>
            ) : null}
            {icons.map(({ Icon }, i) => (
                <IconWrapper key={i} left={getIconOffset(slotIndex + i)} top={1} zIndex={1}>
                    <Icon {...DEFAULT_ICON_PROPS} />
                </IconWrapper>
            ))}
        </>
    );
};
